import script from "./workflow-review-subnav-secondary-left.vue?vue&type=script&setup=true&lang=ts"
export * from "./workflow-review-subnav-secondary-left.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__